// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1ksyi","signatureButtonsRight":"ModalSign_signatureButtonsRight__PS_k8"};